import { render, staticRenderFns } from "./AddToHomeScreen.vue?vue&type=template&id=5232b7e2"
import script from "./AddToHomeScreen.vue?vue&type=script&lang=js"
export * from "./AddToHomeScreen.vue?vue&type=script&lang=js"
import style0 from "./AddToHomeScreen.vue?vue&type=style&index=0&id=5232b7e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports